/**
 * Determine if a rich text field is empty
 *
 * @param html
 * @returns {boolean}
 */
export function isRichTextEmpty(html = '') {
  return (
    html
      .replace(/<[^>]*>/g, '')
      .replace(/&nbsp;/gi, ' ')
      .trim() === ''
  );
}
